import { getSafeGutter as we, validateGutter as Ae } from "@bedrock-layout/spacing-constants";
import { Stack as Ie } from "@bedrock-layout/stack";
import { forwardRefWithAs as je } from "@bedrock-layout/type-utils";
import { useContainerQuery as $e } from "@bedrock-layout/use-container-query";
import { useForwardedRef as Me } from "@bedrock-layout/use-forwarded-ref";
import re from "react";
import fe from "styled-components";
var D = { exports: {} }, te = { exports: {} }, g = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ye;
function Ye() {
  if (ye)
    return g;
  ye = 1;
  var r = typeof Symbol == "function" && Symbol.for, p = r ? Symbol.for("react.element") : 60103, i = r ? Symbol.for("react.portal") : 60106, a = r ? Symbol.for("react.fragment") : 60107, c = r ? Symbol.for("react.strict_mode") : 60108, s = r ? Symbol.for("react.profiler") : 60114, m = r ? Symbol.for("react.provider") : 60109, f = r ? Symbol.for("react.context") : 60110, R = r ? Symbol.for("react.async_mode") : 60111, O = r ? Symbol.for("react.concurrent_mode") : 60111, T = r ? Symbol.for("react.forward_ref") : 60112, x = r ? Symbol.for("react.suspense") : 60113, C = r ? Symbol.for("react.suspense_list") : 60120, w = r ? Symbol.for("react.memo") : 60115, M = r ? Symbol.for("react.lazy") : 60116, _ = r ? Symbol.for("react.block") : 60121, j = r ? Symbol.for("react.fundamental") : 60117, Y = r ? Symbol.for("react.responder") : 60118, F = r ? Symbol.for("react.scope") : 60119;
  function I(n) {
    if (typeof n == "object" && n !== null) {
      var W = n.$$typeof;
      switch (W) {
        case p:
          switch (n = n.type, n) {
            case R:
            case O:
            case a:
            case s:
            case c:
            case x:
              return n;
            default:
              switch (n = n && n.$$typeof, n) {
                case f:
                case T:
                case M:
                case w:
                case m:
                  return n;
                default:
                  return W;
              }
          }
        case i:
          return W;
      }
    }
  }
  function A(n) {
    return I(n) === O;
  }
  return g.AsyncMode = R, g.ConcurrentMode = O, g.ContextConsumer = f, g.ContextProvider = m, g.Element = p, g.ForwardRef = T, g.Fragment = a, g.Lazy = M, g.Memo = w, g.Portal = i, g.Profiler = s, g.StrictMode = c, g.Suspense = x, g.isAsyncMode = function(n) {
    return A(n) || I(n) === R;
  }, g.isConcurrentMode = A, g.isContextConsumer = function(n) {
    return I(n) === f;
  }, g.isContextProvider = function(n) {
    return I(n) === m;
  }, g.isElement = function(n) {
    return typeof n == "object" && n !== null && n.$$typeof === p;
  }, g.isForwardRef = function(n) {
    return I(n) === T;
  }, g.isFragment = function(n) {
    return I(n) === a;
  }, g.isLazy = function(n) {
    return I(n) === M;
  }, g.isMemo = function(n) {
    return I(n) === w;
  }, g.isPortal = function(n) {
    return I(n) === i;
  }, g.isProfiler = function(n) {
    return I(n) === s;
  }, g.isStrictMode = function(n) {
    return I(n) === c;
  }, g.isSuspense = function(n) {
    return I(n) === x;
  }, g.isValidElementType = function(n) {
    return typeof n == "string" || typeof n == "function" || n === a || n === O || n === s || n === c || n === x || n === C || typeof n == "object" && n !== null && (n.$$typeof === M || n.$$typeof === w || n.$$typeof === m || n.$$typeof === f || n.$$typeof === T || n.$$typeof === j || n.$$typeof === Y || n.$$typeof === F || n.$$typeof === _);
  }, g.typeOf = I, g;
}
var S = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ve;
function qe() {
  return ve || (ve = 1, process.env.NODE_ENV !== "production" && function() {
    var r = typeof Symbol == "function" && Symbol.for, p = r ? Symbol.for("react.element") : 60103, i = r ? Symbol.for("react.portal") : 60106, a = r ? Symbol.for("react.fragment") : 60107, c = r ? Symbol.for("react.strict_mode") : 60108, s = r ? Symbol.for("react.profiler") : 60114, m = r ? Symbol.for("react.provider") : 60109, f = r ? Symbol.for("react.context") : 60110, R = r ? Symbol.for("react.async_mode") : 60111, O = r ? Symbol.for("react.concurrent_mode") : 60111, T = r ? Symbol.for("react.forward_ref") : 60112, x = r ? Symbol.for("react.suspense") : 60113, C = r ? Symbol.for("react.suspense_list") : 60120, w = r ? Symbol.for("react.memo") : 60115, M = r ? Symbol.for("react.lazy") : 60116, _ = r ? Symbol.for("react.block") : 60121, j = r ? Symbol.for("react.fundamental") : 60117, Y = r ? Symbol.for("react.responder") : 60118, F = r ? Symbol.for("react.scope") : 60119;
    function I(t) {
      return typeof t == "string" || typeof t == "function" || t === a || t === O || t === s || t === c || t === x || t === C || typeof t == "object" && t !== null && (t.$$typeof === M || t.$$typeof === w || t.$$typeof === m || t.$$typeof === f || t.$$typeof === T || t.$$typeof === j || t.$$typeof === Y || t.$$typeof === F || t.$$typeof === _);
    }
    function A(t) {
      if (typeof t == "object" && t !== null) {
        var k = t.$$typeof;
        switch (k) {
          case p:
            var V = t.type;
            switch (V) {
              case R:
              case O:
              case a:
              case s:
              case c:
              case x:
                return V;
              default:
                var de = V && V.$$typeof;
                switch (de) {
                  case f:
                  case T:
                  case M:
                  case w:
                  case m:
                    return de;
                  default:
                    return k;
                }
            }
          case i:
            return k;
        }
      }
    }
    var n = R, W = O, X = f, G = m, H = p, J = T, N = a, K = M, Q = w, z = i, Z = s, q = c, L = x, B = !1;
    function ee(t) {
      return B || (B = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), e(t) || A(t) === R;
    }
    function e(t) {
      return A(t) === O;
    }
    function o(t) {
      return A(t) === f;
    }
    function v(t) {
      return A(t) === m;
    }
    function d(t) {
      return typeof t == "object" && t !== null && t.$$typeof === p;
    }
    function u(t) {
      return A(t) === T;
    }
    function b(t) {
      return A(t) === a;
    }
    function l(t) {
      return A(t) === M;
    }
    function y(t) {
      return A(t) === w;
    }
    function h(t) {
      return A(t) === i;
    }
    function P(t) {
      return A(t) === s;
    }
    function E(t) {
      return A(t) === c;
    }
    function $(t) {
      return A(t) === x;
    }
    S.AsyncMode = n, S.ConcurrentMode = W, S.ContextConsumer = X, S.ContextProvider = G, S.Element = H, S.ForwardRef = J, S.Fragment = N, S.Lazy = K, S.Memo = Q, S.Portal = z, S.Profiler = Z, S.StrictMode = q, S.Suspense = L, S.isAsyncMode = ee, S.isConcurrentMode = e, S.isContextConsumer = o, S.isContextProvider = v, S.isElement = d, S.isForwardRef = u, S.isFragment = b, S.isLazy = l, S.isMemo = y, S.isPortal = h, S.isProfiler = P, S.isStrictMode = E, S.isSuspense = $, S.isValidElementType = I, S.typeOf = A;
  }()), S;
}
var me;
function Oe() {
  return me || (me = 1, function(r) {
    process.env.NODE_ENV === "production" ? r.exports = Ye() : r.exports = qe();
  }(te)), te.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var ne, be;
function ke() {
  if (be)
    return ne;
  be = 1;
  var r = Object.getOwnPropertySymbols, p = Object.prototype.hasOwnProperty, i = Object.prototype.propertyIsEnumerable;
  function a(s) {
    if (s == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(s);
  }
  function c() {
    try {
      if (!Object.assign)
        return !1;
      var s = new String("abc");
      if (s[5] = "de", Object.getOwnPropertyNames(s)[0] === "5")
        return !1;
      for (var m = {}, f = 0; f < 10; f++)
        m["_" + String.fromCharCode(f)] = f;
      var R = Object.getOwnPropertyNames(m).map(function(T) {
        return m[T];
      });
      if (R.join("") !== "0123456789")
        return !1;
      var O = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(T) {
        O[T] = T;
      }), Object.keys(Object.assign({}, O)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return ne = c() ? Object.assign : function(s, m) {
    for (var f, R = a(s), O, T = 1; T < arguments.length; T++) {
      f = Object(arguments[T]);
      for (var x in f)
        p.call(f, x) && (R[x] = f[x]);
      if (r) {
        O = r(f);
        for (var C = 0; C < O.length; C++)
          i.call(f, O[C]) && (R[O[C]] = f[O[C]]);
      }
    }
    return R;
  }, ne;
}
var oe, he;
function le() {
  if (he)
    return oe;
  he = 1;
  var r = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return oe = r, oe;
}
var ae, Ee;
function xe() {
  return Ee || (Ee = 1, ae = Function.call.bind(Object.prototype.hasOwnProperty)), ae;
}
var ie, Te;
function De() {
  if (Te)
    return ie;
  Te = 1;
  var r = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var p = le(), i = {}, a = xe();
    r = function(s) {
      var m = "Warning: " + s;
      typeof console < "u" && console.error(m);
      try {
        throw new Error(m);
      } catch {
      }
    };
  }
  function c(s, m, f, R, O) {
    if (process.env.NODE_ENV !== "production") {
      for (var T in s)
        if (a(s, T)) {
          var x;
          try {
            if (typeof s[T] != "function") {
              var C = Error(
                (R || "React class") + ": " + f + " type `" + T + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof s[T] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw C.name = "Invariant Violation", C;
            }
            x = s[T](m, T, R, f, null, p);
          } catch (M) {
            x = M;
          }
          if (x && !(x instanceof Error) && r(
            (R || "React class") + ": type specification of " + f + " `" + T + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof x + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), x instanceof Error && !(x.message in i)) {
            i[x.message] = !0;
            var w = O ? O() : "";
            r(
              "Failed " + f + " type: " + x.message + (w != null ? w : "")
            );
          }
        }
    }
  }
  return c.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (i = {});
  }, ie = c, ie;
}
var se, ge;
function We() {
  if (ge)
    return se;
  ge = 1;
  var r = Oe(), p = ke(), i = le(), a = xe(), c = De(), s = function() {
  };
  process.env.NODE_ENV !== "production" && (s = function(f) {
    var R = "Warning: " + f;
    typeof console < "u" && console.error(R);
    try {
      throw new Error(R);
    } catch {
    }
  });
  function m() {
    return null;
  }
  return se = function(f, R) {
    var O = typeof Symbol == "function" && Symbol.iterator, T = "@@iterator";
    function x(e) {
      var o = e && (O && e[O] || e[T]);
      if (typeof o == "function")
        return o;
    }
    var C = "<<anonymous>>", w = {
      array: Y("array"),
      bigint: Y("bigint"),
      bool: Y("boolean"),
      func: Y("function"),
      number: Y("number"),
      object: Y("object"),
      string: Y("string"),
      symbol: Y("symbol"),
      any: F(),
      arrayOf: I,
      element: A(),
      elementType: n(),
      instanceOf: W,
      node: J(),
      objectOf: G,
      oneOf: X,
      oneOfType: H,
      shape: K,
      exact: Q
    };
    function M(e, o) {
      return e === o ? e !== 0 || 1 / e === 1 / o : e !== e && o !== o;
    }
    function _(e, o) {
      this.message = e, this.data = o && typeof o == "object" ? o : {}, this.stack = "";
    }
    _.prototype = Error.prototype;
    function j(e) {
      if (process.env.NODE_ENV !== "production")
        var o = {}, v = 0;
      function d(b, l, y, h, P, E, $) {
        if (h = h || C, E = E || y, $ !== i) {
          if (R) {
            var t = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw t.name = "Invariant Violation", t;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var k = h + ":" + y;
            !o[k] && v < 3 && (s(
              "You are manually calling a React.PropTypes validation function for the `" + E + "` prop on `" + h + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), o[k] = !0, v++);
          }
        }
        return l[y] == null ? b ? l[y] === null ? new _("The " + P + " `" + E + "` is marked as required " + ("in `" + h + "`, but its value is `null`.")) : new _("The " + P + " `" + E + "` is marked as required in " + ("`" + h + "`, but its value is `undefined`.")) : null : e(l, y, h, P, E);
      }
      var u = d.bind(null, !1);
      return u.isRequired = d.bind(null, !0), u;
    }
    function Y(e) {
      function o(v, d, u, b, l, y) {
        var h = v[d], P = q(h);
        if (P !== e) {
          var E = L(h);
          return new _(
            "Invalid " + b + " `" + l + "` of type " + ("`" + E + "` supplied to `" + u + "`, expected ") + ("`" + e + "`."),
            { expectedType: e }
          );
        }
        return null;
      }
      return j(o);
    }
    function F() {
      return j(m);
    }
    function I(e) {
      function o(v, d, u, b, l) {
        if (typeof e != "function")
          return new _("Property `" + l + "` of component `" + u + "` has invalid PropType notation inside arrayOf.");
        var y = v[d];
        if (!Array.isArray(y)) {
          var h = q(y);
          return new _("Invalid " + b + " `" + l + "` of type " + ("`" + h + "` supplied to `" + u + "`, expected an array."));
        }
        for (var P = 0; P < y.length; P++) {
          var E = e(y, P, u, b, l + "[" + P + "]", i);
          if (E instanceof Error)
            return E;
        }
        return null;
      }
      return j(o);
    }
    function A() {
      function e(o, v, d, u, b) {
        var l = o[v];
        if (!f(l)) {
          var y = q(l);
          return new _("Invalid " + u + " `" + b + "` of type " + ("`" + y + "` supplied to `" + d + "`, expected a single ReactElement."));
        }
        return null;
      }
      return j(e);
    }
    function n() {
      function e(o, v, d, u, b) {
        var l = o[v];
        if (!r.isValidElementType(l)) {
          var y = q(l);
          return new _("Invalid " + u + " `" + b + "` of type " + ("`" + y + "` supplied to `" + d + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return j(e);
    }
    function W(e) {
      function o(v, d, u, b, l) {
        if (!(v[d] instanceof e)) {
          var y = e.name || C, h = ee(v[d]);
          return new _("Invalid " + b + " `" + l + "` of type " + ("`" + h + "` supplied to `" + u + "`, expected ") + ("instance of `" + y + "`."));
        }
        return null;
      }
      return j(o);
    }
    function X(e) {
      if (!Array.isArray(e))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? s(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : s("Invalid argument supplied to oneOf, expected an array.")), m;
      function o(v, d, u, b, l) {
        for (var y = v[d], h = 0; h < e.length; h++)
          if (M(y, e[h]))
            return null;
        var P = JSON.stringify(e, function($, t) {
          var k = L(t);
          return k === "symbol" ? String(t) : t;
        });
        return new _("Invalid " + b + " `" + l + "` of value `" + String(y) + "` " + ("supplied to `" + u + "`, expected one of " + P + "."));
      }
      return j(o);
    }
    function G(e) {
      function o(v, d, u, b, l) {
        if (typeof e != "function")
          return new _("Property `" + l + "` of component `" + u + "` has invalid PropType notation inside objectOf.");
        var y = v[d], h = q(y);
        if (h !== "object")
          return new _("Invalid " + b + " `" + l + "` of type " + ("`" + h + "` supplied to `" + u + "`, expected an object."));
        for (var P in y)
          if (a(y, P)) {
            var E = e(y, P, u, b, l + "." + P, i);
            if (E instanceof Error)
              return E;
          }
        return null;
      }
      return j(o);
    }
    function H(e) {
      if (!Array.isArray(e))
        return process.env.NODE_ENV !== "production" && s("Invalid argument supplied to oneOfType, expected an instance of array."), m;
      for (var o = 0; o < e.length; o++) {
        var v = e[o];
        if (typeof v != "function")
          return s(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + B(v) + " at index " + o + "."
          ), m;
      }
      function d(u, b, l, y, h) {
        for (var P = [], E = 0; E < e.length; E++) {
          var $ = e[E], t = $(u, b, l, y, h, i);
          if (t == null)
            return null;
          t.data && a(t.data, "expectedType") && P.push(t.data.expectedType);
        }
        var k = P.length > 0 ? ", expected one of type [" + P.join(", ") + "]" : "";
        return new _("Invalid " + y + " `" + h + "` supplied to " + ("`" + l + "`" + k + "."));
      }
      return j(d);
    }
    function J() {
      function e(o, v, d, u, b) {
        return z(o[v]) ? null : new _("Invalid " + u + " `" + b + "` supplied to " + ("`" + d + "`, expected a ReactNode."));
      }
      return j(e);
    }
    function N(e, o, v, d, u) {
      return new _(
        (e || "React class") + ": " + o + " type `" + v + "." + d + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + u + "`."
      );
    }
    function K(e) {
      function o(v, d, u, b, l) {
        var y = v[d], h = q(y);
        if (h !== "object")
          return new _("Invalid " + b + " `" + l + "` of type `" + h + "` " + ("supplied to `" + u + "`, expected `object`."));
        for (var P in e) {
          var E = e[P];
          if (typeof E != "function")
            return N(u, b, l, P, L(E));
          var $ = E(y, P, u, b, l + "." + P, i);
          if ($)
            return $;
        }
        return null;
      }
      return j(o);
    }
    function Q(e) {
      function o(v, d, u, b, l) {
        var y = v[d], h = q(y);
        if (h !== "object")
          return new _("Invalid " + b + " `" + l + "` of type `" + h + "` " + ("supplied to `" + u + "`, expected `object`."));
        var P = p({}, v[d], e);
        for (var E in P) {
          var $ = e[E];
          if (a(e, E) && typeof $ != "function")
            return N(u, b, l, E, L($));
          if (!$)
            return new _(
              "Invalid " + b + " `" + l + "` key `" + E + "` supplied to `" + u + "`.\nBad object: " + JSON.stringify(v[d], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(e), null, "  ")
            );
          var t = $(y, E, u, b, l + "." + E, i);
          if (t)
            return t;
        }
        return null;
      }
      return j(o);
    }
    function z(e) {
      switch (typeof e) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !e;
        case "object":
          if (Array.isArray(e))
            return e.every(z);
          if (e === null || f(e))
            return !0;
          var o = x(e);
          if (o) {
            var v = o.call(e), d;
            if (o !== e.entries) {
              for (; !(d = v.next()).done; )
                if (!z(d.value))
                  return !1;
            } else
              for (; !(d = v.next()).done; ) {
                var u = d.value;
                if (u && !z(u[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function Z(e, o) {
      return e === "symbol" ? !0 : o ? o["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && o instanceof Symbol : !1;
    }
    function q(e) {
      var o = typeof e;
      return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : Z(o, e) ? "symbol" : o;
    }
    function L(e) {
      if (typeof e > "u" || e === null)
        return "" + e;
      var o = q(e);
      if (o === "object") {
        if (e instanceof Date)
          return "date";
        if (e instanceof RegExp)
          return "regexp";
      }
      return o;
    }
    function B(e) {
      var o = L(e);
      switch (o) {
        case "array":
        case "object":
          return "an " + o;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + o;
        default:
          return o;
      }
    }
    function ee(e) {
      return !e.constructor || !e.constructor.name ? C : e.constructor.name;
    }
    return w.checkPropTypes = c, w.resetWarningCache = c.resetWarningCache, w.PropTypes = w, w;
  }, se;
}
var ue, Se;
function Le() {
  if (Se)
    return ue;
  Se = 1;
  var r = le();
  function p() {
  }
  function i() {
  }
  return i.resetWarningCache = p, ue = function() {
    function a(m, f, R, O, T, x) {
      if (x !== r) {
        var C = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw C.name = "Invariant Violation", C;
      }
    }
    a.isRequired = a;
    function c() {
      return a;
    }
    var s = {
      array: a,
      bigint: a,
      bool: a,
      func: a,
      number: a,
      object: a,
      string: a,
      symbol: a,
      any: a,
      arrayOf: c,
      element: a,
      elementType: a,
      instanceOf: c,
      node: a,
      objectOf: c,
      oneOf: c,
      oneOfType: c,
      shape: c,
      exact: c,
      checkPropTypes: i,
      resetWarningCache: p
    };
    return s.PropTypes = s, s;
  }, ue;
}
if (process.env.NODE_ENV !== "production") {
  var ze = Oe(), Fe = !0;
  D.exports = We()(ze.isElement, Fe);
} else
  D.exports = Le()();
const Ue = fe.div.attrs(
  ({ dense: r, theme: p, gutter: i, columns: a = 1, style: c }) => {
    const s = we(p, i), m = a > 0 ? a : 1;
    return {
      "data-bedrock-columns": r ? "dense" : "",
      style: { ...c, "--gutter": s, "--columns": m }
    };
  }
)`
  @property --gutter {
    syntax: "<length-percentage>";
    inherits: false;
    initial-value: 0;
  }

  @property --columns {
    syntax: "<number>";
    inherits: true;
    initial-value: 1;
  }

  box-sizing: border-box;
  > * {
    margin: 0;
  }

  display: grid;
  grid-template-columns: repeat(var(--columns, 1), 1fr);
  gap: var(--gutter, 0px);
  grid-auto-flow: row ${({ dense: r = !1 }) => r === !0 ? "dense" : ""};
`, Pe = je(
  ({ columns: r, dense: p, switchAt: i, as: a, ...c }, s) => {
    const m = Me(s), f = m.current, R = re.useMemo(() => typeof i == "string" ? pe(i, f) : typeof i == "number" && i > -1 ? i : null, [i, f]);
    return $e(f, R || 0) ? /* @__PURE__ */ re.createElement(Ie, {
      as: a,
      ref: m,
      ...c
    }) : /* @__PURE__ */ re.createElement(Ue, {
      as: a,
      ref: m,
      columns: r,
      dense: p,
      ...c
    });
  }
), Re = fe(Pe).attrs(({ as: r, forwardedAs: p }) => ({
  forwardedAs: r != null ? r : p,
  as: Pe
}))``;
Re.displayName = "Columns";
Re.propTypes = {
  gutter: Ae,
  columns: D.exports.number,
  dense: D.exports.bool,
  switchAt: D.exports.oneOfType([D.exports.string, D.exports.number])
};
const Ne = (r) => typeof r == "number" ? r : 1, _e = fe.div.attrs(
  ({ span: r, style: p, offsetStart: i = 0, offsetEnd: a = 0 }) => {
    const c = i > 0 ? i : void 0, s = a > 0 ? a : void 0;
    return {
      "data-bedrock-column": "",
      span: void 0,
      style: {
        ...p,
        "--span": Math.max(Ne(r), 1),
        "--offsetStart": c,
        "--offsetEnd": s
      }
    };
  }
)`
  @property --span {
    syntax: "<number>";
    inherits: true;
    initial-value: 1;
  }

  @property --offsetStart {
    syntax: "<number>";
    inherits: true;
    initial-value: 1;
  }

  @property --offsetEnd {
    syntax: "<number>";
    inherits: true;
    initial-value: 1;
  }

  grid-column: span min(var(--span, 1), var(--columns, 1));

  &[style*="--offset"] {
    display: contents;
  }

  &[style*="--offset"] > * {
    grid-column: span min(var(--span, 1), var(--columns, 1));
  }

  &[style*="--offsetStart"]::before {
    content: "";
    grid-column: span min(var(--offsetStart, 1), var(--columns, 1));
  }

  &[style*="--offsetEnd"]::after {
    content: "";
    grid-column: span min(var(--offsetEnd, 1), var(--columns, 1));
  }
`;
_e.displayName = "Column";
_e.propTypes = {
  span: D.exports.number
};
const U = 96;
function Ce(r) {
  var a;
  r = String(r);
  const p = parseFloat(r), [, i] = (a = r.match(/[\d.\-+]*\s*(.*)/)) != null ? a : ["", ""];
  return [p, i];
}
function pe(r, p) {
  if (!r)
    return null;
  const i = p != null ? p : document.body, a = (r != null ? r : "px").trim().toLowerCase();
  switch (a) {
    case "vmin":
    case "vmax":
    case "vh":
    case "vw":
    case "%":
      return null;
    case "ch":
    case "ex":
      return Be(a, i);
    case "em":
      return ce(i, "font-size");
    case "rem":
      return ce(document.body, "font-size");
    case "in":
      return U;
    case "cm":
      return U / 2.54;
    case "mm":
      return U / 25.4;
    case "pt":
      return U / 72;
    case "pc":
      return U / 6;
    case "px":
      return 1;
    default: {
      const [c, s] = Ce(a);
      if (isNaN(c))
        return null;
      if (!s)
        return c;
      const m = pe(s, p);
      return typeof m == "number" ? c * m : null;
    }
  }
}
function ce(r, p) {
  var c;
  const [i, a] = Ce(
    getComputedStyle(r).getPropertyValue(p)
  );
  return i * ((c = pe(a, r)) != null ? c : 1);
}
function Be(r, p) {
  const i = document.createElement("div");
  i.style.height = "128" + r, p.appendChild(i);
  const a = ce(i, "height") / 128;
  return p.removeChild(i), a;
}
export {
  _e as Column,
  Re as Columns
};
